export default __webpack_public_path__ + "static/media/jira.ecf50591.svg";